import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export const DealerOrderDisclaimer: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <p
      className={clsx(
        "px-2 md:px-4 py-1 md:py-2 border-t border-dashed border-edge-2 text-ink-2",
        "font-light text-xs md:text-sm"
      )}
    >
      {t("dealerOrderModal.disclaimer")}
    </p>
  );
};
